import React from 'react';

import { Bar } from "react-chartjs-2";

import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import Button from 'components/CustomButtons/Button.js';

import Edit from '@material-ui/icons/Edit';
import AccessTime from '@material-ui/icons/AccessTime';
import Refresh from '@material-ui/icons/Refresh';

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { WithApp } from "contexts/appContext";
import moment from "moment";

const useStyles = makeStyles(styles);

export default WithApp(function BarChart(props) {
  const classes = useStyles();

  const data = {
    labels: props.labels,
    datasets: [
      {
        label: "Ventas",
        data: props.data,
        backgroundColor: ["white"],
        borderColor: ["rgb(255, 99, 132)"],
        borderWidth: 1
      }
    ]
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text:
          !!props.formatDate && props.formatDate === "P"
            ? "Periodo " +
              moment(props.date).format(
                !!props.formatDate && props.formatDate === "P"
                  ? "YYYY-MM"
                  : "YYYY-MM-DD"
              )
            : "Fecha " +
              moment(props.date).format(
                !!props.formatDate && props.formatDate === "P"
                  ? "YYYY-MM"
                  : "YYYY-MM-DD"
              ),
        color: "white"
      },
      legend: {
        labels: {
          color: "white"
        }
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };

  return (
    <Card chart className={classes.cardHover}>
      <CardHeader color="info" className={classes.cardHeaderHover}>
        <Bar data={data} options={options} height={68} />
      </CardHeader>
      <CardBody>
        <div className={classes.cardHoverUnder}>
          {!!props.refresh ? (
            <Tooltip
              id="tooltip-top"
              title="Actualizar"
              placement="bottom"
              classes={{ tooltip: classes.tooltip }}
            >
              <Button simple color="info" justIcon onClick={() => props.refresh()}>
                <Refresh className={classes.underChartIcons} />
              </Button>
            </Tooltip>
          ) : undefined}
          {/* <Tooltip
            id="tooltip-top"
            title="Change Date"
            placement="bottom"
            classes={{ tooltip: classes.tooltip }}
          >
            <Button color="transparent" simple justIcon>
              <Edit className={classes.underChartIcons} />
            </Button>
          </Tooltip> */}
        </div>
        <h4 className={classes.cardTitle}>{props.title}</h4>
        {props.subTitle ? <p className={classes.cardCategory}>{props.subTitle}</p> : undefined}
      </CardBody>
      <CardFooter chart>
        {props.lastUpdate ? (
          <div className={classes.stats}>
            <AccessTime /> actualizado hace {props.lastUpdate}
          </div>
        ) : undefined}
      </CardFooter>
    </Card>
  );
});
